import { FC } from 'react'
import { useT } from '../../../../../../../_metronic/i18n/Metronici18n'
import { formatDateTime } from '../../../../../../../_metronic/helpers'
import { EstudoDicom, SolicitacaoExameImagem } from '../../../../atendimento/core/_models'
import { AbrirEstudoDicomBotao } from './AbrirEstudoDicomBotao'
import { EstudoDicomMiniatura } from './EstudoDicomMiniatura'
import { formatarNumeroPedido } from './numeroPedido'
import styles from './ExamesImagem.module.css'

type Props = {
  idAtendimento: number
  estudos: EstudoDicom[]
  solicitacoes: SolicitacaoExameImagem[]
  tituloId: string
  onAbrirEstudo: (estudo: EstudoDicom) => void
}

const Vazio: FC<{ title: string }> = ({ title }) => (
  <span className={styles.vazio} title={title}>
    —
  </span>
)

export const EstudosDicomLista: FC<Props> = ({
  idAtendimento,
  estudos,
  solicitacoes,
  tituloId,
  onAbrirEstudo,
}) => {
  const { t } = useT()

  const numeroDoPedido = (estudo: EstudoDicom) => {
    const pedido = estudo.solicitacao
      ? solicitacoes.find((s) => s.id === estudo.solicitacao?.id)
      : undefined
    return pedido ? formatarNumeroPedido(pedido.accessionNumber, pedido.sequencia).exibicao : null
  }

  return (
    <div className={styles.rolagem} role='region' aria-labelledby={tituloId} tabIndex={0}>
      <table className={`${styles.tabela} ${styles.tabelaEstudos}`} aria-labelledby={tituloId}>
        <colgroup>
          <col className={styles.colNumero} />
          <col className={styles.colData} />
          <col />
          <col className={styles.colSeries} />
          <col className={styles.colInstancias} />
          <col className={styles.colImagem} />
        </colgroup>
        <thead>
          <tr>
            <th scope='col' className={styles.direita}>
              {t('exames_imagem.estudos.pedido')}
            </th>
            <th scope='col'>{t('exames_imagem.estudos.data')}</th>
            <th scope='col'>{t('exames_imagem.estudos.modalidade')}</th>
            <th scope='col' className={styles.direita}>
              {t('exames_imagem.estudos.series')}
            </th>
            <th scope='col' className={styles.direita}>
              {t('exames_imagem.estudos.instancias')}
            </th>
            <th scope='col' className={styles.direita}>
              {t('exames_imagem.estudos.imagem')}
            </th>
          </tr>
        </thead>
        <tbody>
          {estudos.map((estudo) => {
            const numero = numeroDoPedido(estudo)
            const semValor = t('exames_imagem.sem_valor')
            return (
              <tr key={estudo.id}>
                <td className={`${styles.direita} fw-bold`} title={numero ?? undefined}>
                  {numero ?? <Vazio title={t('exames_imagem.estudos.sem_pedido')} />}
                </td>
                <td>
                  {estudo.dataEstudo ? (
                    formatDateTime(estudo.dataEstudo)
                  ) : (
                    <Vazio title={semValor} />
                  )}
                </td>
                <td>{estudo.modalidade ?? <Vazio title={semValor} />}</td>
                <td className={styles.direita}>
                  {estudo.quantidadeSeries ?? <Vazio title={semValor} />}
                </td>
                <td className={styles.direita}>
                  {estudo.quantidadeInstancias ?? <Vazio title={semValor} />}
                </td>
                <td className={styles.direita}>
                  {estudo.situacaoVinculo === 'VINCULADO' ? (
                    <div className={styles.celulaImagem}>
                      <EstudoDicomMiniatura idAtendimento={idAtendimento} estudo={estudo} />
                      <AbrirEstudoDicomBotao
                        idAtendimento={idAtendimento}
                        estudo={estudo}
                        onAbrir={onAbrirEstudo}
                      />
                    </div>
                  ) : (
                    <Vazio title={t('exames_imagem.viewer.indisponivel')} />
                  )}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
